<template>
  <div  style="margin-left: 110px; margin-right: 110px;">
    <b-tabs card @input="handleTabChange">
      <b-tab title="已购产品" :active="activeTabIndex === 0">
        <div class="tablePage" v-cloak>
          <table border="1" style="width: 80%; border: none;">
            <tr>
              <td style="text-align: left; width: 30%; border: none;">当前用户: {{ this.$store.state.username }}</td>
              <td style="text-align: left; width: 70%; border: none;">公司域名: {{ sldtld }}</td>
            </tr>
            <tr>
              <td style="text-align: left; width: 30%; border: none;">授权起始时间: {{ company_nbf }}</td>
              <td style="text-align: left; width: 70%; border: none;">授权结束时间: {{ company_exp }}</td>
            </tr>
          </table>
      
          <div style="margin-top: 10px; margin-bottom: 20px;">
            <span style="margin-right: 10px">请选购买的产品类型</span>
            <select id="category_select" v-model="category_selected" @change='getCategory'>
              <option value="product">硬件</option>
              <option value="plan">流量</option>
              <option value="custom">定制产品</option>
            </select>
          </div>
      
          <!-- 表格-->
          <ve-table
            :columns="tableConfig.columns"
            :table-data="tableConfig.tableData"
            :paging-index="(pageIndex-1)*pageSize"
            :cell-style-option="cellStyleOption"
            :border-x="true"
            :border-y="true">
          </ve-table>
      
          <!-- 分页-->
          <ve-pagination
            @on-page-number-change="pageChange"
            @on-page-size-change="pageSizeChange"
            :total="dataNum"
            :page-size="pageSize"
            :layout="['total', 'prev', 'pager', 'next', 'sizer', 'jumper']">
          </ve-pagination>
      
          <div v-if="msg1" class="message">
            {{ msg1 }}
          </div>
      
          <b-modal ref="modal" hide-footer centered>
            <template v-slot:modal-title>查看授权码</template>
            <div>
              <div class="div-inline" ref="container">
                <button class="button-demo" @click="doCopy" style="margin-right: 5px;">复制</button>
                <button class="button-demo" @click="doDownload()">下载</button>
                <div v-if="msg2" class="message">
                  {{ msg2 }}
                </div>
              </div> 
              <textarea ref="vuetext" v-model="key" rows="10" style="min-width: 100%;resize: none;" readonly></textarea>
            </div>
            <button class="button-close" @click="hideModal">关闭</button>
          </b-modal>

          <b-modal ref="modalRemark" hide-footer centered>
            <template v-slot:modal-title>修改(网关代码: {{ remarkGwcode }})备注</template>
            <div>
              <div class="div-inline" ref="containerRemark" style="align-items: center;">
                <button 
                  class="btn btn-primary button-demo" 
                  :disabled="remarkValue === remarkOriginalValue"
                  @click="saveRemark"
                  style="margin-right: 5px;"
                >保存</button>
                <div v-if="msgRemark" class="message">
                  {{ msgRemark }} 
                </div>
              </div>
              <input style="min-width: 100%;" type="text" v-model="remarkValue"/>
            </div>
            <button class="button-close" @click="hideModalRemark" style="margin-top: 5px;">关闭</button>
          </b-modal>
      
        </div>
      </b-tab>
      <b-tab title="收货地址" :active="activeTabIndex === 1">
        <div class="tablePage" v-cloak>
          <p class="p-a">当前用户: {{ this.$store.state.username }}</p>
          <div>
            <table border="1" style="width: 80%; border: none;">
              <tr>
                <td style="text-align: left; width: 15%; border: none;">姓名</td>
                <td style="text-align: left; width: 85%; border: none;"><input id="name_input" style="width: 300px;" type="text" v-model="name"/></td>
              </tr>
              <tr>
                <td style="text-align: left; width: 15%; border: none;">地址</td>
                <td style="text-align: left; width: 85%; border: none;"><input id="address_input" style="width: 300px;" type="text" v-model="address"/></td>
              </tr>
              <tr>
                <td style="text-align: left; width: 15%; border: none;">电话</td>
                <td style="text-align: left; width: 85%; border: none;"><input id="phone_input" style="width: 300px;" type="text" v-model="phone"/></td>
              </tr>
            </table>
          </div>
          <div>
            <button class="button-demo" @click="doSave" style="margin-right: 5px;">保存</button>
            <div v-if="msg3" class="message">
              {{ msg3 }}
            </div>
          </div> 
        </div>
      </div>

        </div>
      </b-tab>
    </b-tabs>
  </div>

</template>

<script>
import "vue-easytable/libs/theme-default/index.css"
import { VeTable, VePagination } from "vue-easytable"
import { saveAs } from 'file-saver' // npm install file-saver

//加入中文支持
import { VeLocale } from "vue-easytable";
import zhCN from "vue-easytable/libs/locale/lang/zh-CN.js";
VeLocale.use(zhCN);

export default {
  components: {
    VeTable,
    VePagination
  },
  data () {
    return {
      cellStyleOption: {
        headerCellClass: ({ column, rowIndex }) => {
          if (rowIndex === 0) {
            return "table-header-cell-class";
          }
        },
      },

      activeTabIndex: 0, // 初始激活的tab索引
      sldtld: '',         // 公司的基础域名, 例如: awmyij.com
      company_nbf: '',    // 公司授权起始时间
      company_exp: '',    // 公司授权结束时间
      name: '',
      address: '',
      phone: '',
      addrData: {}, // 用于保存用户收货地址信息
      category_selected: 'product',
      msg1: '',
      msg2: '',
      msg3: '',
      msgRemark: '',
      remarkOriginalValue: '',
      remarkValue: '',
      remarkGwcode: '',
      remarkRowIndex: 0,
      key: '',
      allData: [],
      pageIndex: 1, /*页码*/
      pageSize: 10, /*每页条数*/
      dataNum: 0, /*数据总条数*/
      tableConfig: {
        tableData: [],
        columns: [
          {
            field: 'out_trade_no',
            key: 'a',
            title: '商户订单号',
            align: 'left'
          },
          {
            field: 'gwcode',
            key: 'b',
            title: '网关代码',
            align: 'left'
          },
          {
            field: 'gwtype',
            key: 'c',
            title: '网关类型',
            align: 'left',
            renderBodyCell: ({ row, column, rowIndex }) => {
              if (row.gwtype === 'gw') {
                return <span>企业网关</span>;
              } else if (row.gwtype === 'mgw') {
                return <span>移动网关</span>;
              } else {
                return <span>移动终端</span>;
              }
            }
          },
          {
            field: 'activated',
            key: 'd',
            title: '激活状态',
            align: 'left',
            renderBodyCell: ({ row, column, rowIndex }) => {
              if (row.activated) {
                return (<span style="color: green;">激活</span>);
              } else {
                return (<span style="color: red;">非激活</span>);
              }
            }
          },
          {
            field: 'formatted_date',
            key: 'e',
            title: '购买时间',
            align: 'left'
          },
          {
            field: 'remark',
            key: 'f',
            title: '备注',
            align: 'left',
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return (
                <div class="div-inline1" style="align-items: center;">
                  <span
                    class="ellipsis-text"
                    title={this.tableConfig.tableData[rowIndex]['remark']}
                    style="display: inline-block; width: 350px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-right: 10px;"
                  >{this.tableConfig.tableData[rowIndex]['remark']}</span>
                  <button
                    class="btn btn-primary button-demo"
                    on-click={() => this.modify_remark(rowIndex)}
                    style="white-space: nowrap;"
                  >编辑</button>
                </div>
              );
            }
          },
          {
            field: "download",
            key: "g",
            title: "下载授权码",
            align: "center",
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return (
                <div class="div-inline1">
                  <button
                    class="btn btn-primary button-demo"
                    on-click={() => this.download(rowIndex)}
                    style="white-space: nowrap; margin-right: 5px;"
                  >下载</button>
                  <button
                    class="btn btn-primary button-demo"
                    on-click={() => this.view(rowIndex)}
                    style="white-space: nowrap;"
                  >查看</button>
                </div>
              );
            }
          },
          {
            field: "operate",
            key: "h",
            title: "网关维护",
            align: "center",
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return (
                <div class="div-inline1">
                  <button
                    class="btn btn-primary button-demo"
                    disabled={row.activated}
                    on-click={() => this.activation(rowIndex)}
                    style="white-space: nowrap; margin-right: 5px;"
                  >激活</button>
                  <button
                    class="btn btn-primary button-demo"
                    disabled={!row.activated}
                    on-click={() => this.deactivate(rowIndex)}
                    style="white-space: nowrap; margin-right: 5px;"
                  >去激活</button>
                  <button
                    class="btn btn-primary button-demo"
                    on-click={() => this.gwdelete(rowIndex)}
                    style="white-space: nowrap;"
                  >删除</button>
                </div>
              );
            }
          }
        ]
      }
    }
  },
  created () {
    this.getAllData();
  },
  methods: {
    handleTabChange(newTabIndex) {
      this.activeTabIndex = newTabIndex; // 更新当前激活的tab索引
      this.msg1 = '';
      this.msg2 = '';
      this.msg3 = '';
    },

    getCategory() {
      this.tableConfig.tableData = [];
      this.msg1 = '';
      this.msg2 = '';

      // alert(this.category_selected);
      if (this.category_selected === 'product') {
        this.tableConfig.columns = [
          {
            field: 'out_trade_no',
            key: 'a',
            title: '商户订单号',
            align: 'left'
          },
          {
            field: 'gwcode',
            key: 'b',
            title: '网关代码',
            align: 'left'
          },
          {
            field: 'gwtype',
            key: 'c',
            title: '网关类型',
            align: 'left',
            renderBodyCell: ({ row, column, rowIndex }) => {
              if (row.gwtype === 'gw') {
                return <span>企业网关</span>;
              } else if (row.gwtype === 'mgw') {
                return <span>移动网关</span>;
              } else {
                return <span>移动终端</span>;
              }
            }
          },
          {
            field: 'activated',
            key: 'd',
            title: '激活状态',
            align: 'left',
            renderBodyCell: ({ row, column, rowIndex }) => {
              if (row.activated) {
                return (<span style="color: green;">激活</span>);
              } else {
                return (<span style="color: red;">非激活</span>);
              }
            }
          },
          {
            field: 'formatted_date',
            key: 'e',
            title: '购买时间',
            align: 'left'
          },
          {
            field: 'remark',
            key: 'f',
            title: '备注',
            align: 'left',
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return (
                <div class="div-inline1" style="align-items: center;">
                  <span
                    class="ellipsis-text"
                    title={this.tableConfig.tableData[rowIndex]['remark']}
                    style="display: inline-block; width: 350px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; margin-right: 10px;"
                  >{this.tableConfig.tableData[rowIndex]['remark']}</span>
                  <button
                    class="btn btn-primary button-demo"
                    on-click={() => this.modify_remark(rowIndex)}
                    style="white-space: nowrap;"
                  >编辑</button>
                </div>
              );
            }
          },
          {
            field: "download",
            key: "g",
            title: "下载授权码",
            align: "center",
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return (
                <div class="div-inline1">
                  <button
                    class="btn btn-primary button-demo"
                    on-click={() => this.download(rowIndex)}
                    style="white-space: nowrap; margin-right: 5px;"
                  >下载</button>
                  <button
                    class="btn btn-primary button-demo"
                    on-click={() => this.view(rowIndex)}
                    style="white-space: nowrap;"
                  >查看</button>
                </div>
              );
            }
          },
          {
            field: "operate",
            key: "h",
            title: "网关维护",
            align: "center",
            renderBodyCell: ({ row, column, rowIndex }, h) => {
              return (
                <div class="div-inline1">
                  <button
                    class="btn btn-primary button-demo"
                    disabled={row.activated}
                    on-click={() => this.activation(rowIndex)}
                    style="white-space: nowrap; margin-right: 5px;"
                  >激活</button>
                  <button
                    class="btn btn-primary button-demo"
                    disabled={!row.activated}
                    on-click={() => this.deactivate(rowIndex)}
                    style="white-space: nowrap; margin-right: 5px;"
                  >去激活</button>
                  <button
                    class="btn btn-primary button-demo"
                    on-click={() => this.gwdelete(rowIndex)}
                    style="white-space: nowrap;"
                  >删除</button>
                </div>
              );
            }
          }
        ];

        var config = {
          method: 'post',
          url: 'account',
          data: {}
        };
   
        this.$axios(config)
          .then(response => {
            if(response.status == 200) {
              const jsonString = response.data.data;
              this.allData = JSON.parse(jsonString);
              this.dataNum = this.allData.length;
              this.getTableData();
            }
          })
          .catch(error => {
            if (error.response) {
                this.msg1 = '服务器响应错误'; // 服务器响应超时或服务器宕机等原因
            } else if (error.request) {
                this.msg1 = '请求未发出或未收到服务器响应'; // 例如服务器不允许跨域资源共享(CORS)
            } else {
                this.msg1 = '发生未知错误';
            }   
          });
      } else if (this.category_selected === 'plan') {
        this.tableConfig.columns = [
          {
            field: 'out_trade_no',
            key: 'a',
            title: '商户订单号',
            align: 'left'
          },
          {
            field: 'planname',
            key: 'b',
            title: '流量套餐名称',
            align: 'left'
          },
          {
            field: 'nbf',
            key: 'c',
            title: '套餐开始时间',
            align: 'left'
          },
          {
            field: 'exp',
            key: 'd',
            title: '套餐结束时间',
            align: 'left'
          },
          {
            field: 'formatted_date',
            key: 'e',
            title: '购买时间',
            align: 'left'
          }
        ];

        var config = {
          method: 'post',
          url: 'plan',
          data: {
            username: this.$store.state.username, // 客户端登录的用户名 电子邮箱
          }
        };

        this.$axios(config)
          .then(response => {
            if(response.status == 200) {
              const jsonString = response.data.data;
              this.allData = JSON.parse(jsonString);
              this.dataNum = this.allData.length;
              this.getTableData();
            }
          })
          .catch(error => {
            if (error.response) {
                this.msg1 = '服务器响应错误'; // 服务器响应超时或服务器宕机等原因
            } else if (error.request) {
                this.msg1 = '请求未发出或未收到服务器响应'; // 例如服务器不允许跨域资源共享(CORS)
            } else {
                this.msg1 = '发生未知错误';
            }   
          });
      } else if (this.category_selected === 'custom') {
        this.tableConfig.columns = [
          {
            field: 'out_trade_no',
            key: 'a',
            title: '商户订单号',
            align: 'left'
          },
          {
            field: 'prodname',
            key: 'b',
            title: '定制产品名称',
            align: 'left'
          },
          {
            field: 'ip',
            key: 'c',
            title: '定制产品 IP 地址',
            align: 'left'
          },
          {
            field: 'formatted_date',
            key: 'e',
            title: '购买时间',
            align: 'left'
          }
        ];

        var config = {
          method: 'post',
          url: 'custom',
          data: {}
        };

        this.$axios(config)
          .then(response => {
            if(response.status == 200) {
              const jsonString = response.data.data;
              this.allData = JSON.parse(jsonString);
              this.dataNum = this.allData.length;
              this.getTableData();
            }
          })
          .catch(error => {
            if (error.response) {
                this.msg1 = '服务器响应错误'; // 服务器响应超时或服务器宕机等原因
            } else if (error.request) {
                this.msg1 = '请求未发出或未收到服务器响应'; // 例如服务器不允许跨域资源共享(CORS)
            } else {
                this.msg1 = '发生未知错误';
            }   
          });
      }


      // this.geoid = this.geo_selected.split('|')[0];
      // this.geoname = this.geo_selected.split('|')[1]; 
    },

    doCopy() {
      var _this = this; // 窗口焦点变化,this指向也发生了变化,这里保留原来的
      _this.$copyText(_this.key, _this.$refs.container).then(
        function(e) {
          _this.msg2 = "已复制到剪贴板!";
        },
        function(e) {
          _this.msg2 = "复制失败!";
        }
      );
    },

    doDownload() {
      var blob = new Blob([this.key], {type: "text/plain;charset=utf-8"});
      saveAs(blob, 'key.txt');
      this.msg2 = "下载成功!";
    },

    doSave() {
      this.msg3 = '';

      if (!this.name || !this.address || !this.phone) {
        this.msg3 = "姓名, 地址和电话都不能为空";
        return;
      }

      var config = {
        method: 'post',
        url: 'addr',
        data: {
          action: this.addrData.name === '' ? 'insert' : 'update',
          name: this.name,
          address: this.address,
          phone: this.phone
        }
      };

      this.$axios(config)
        .then(response => {
          if(response.status == 200) {
            this.msg3 = response.data.message;
            this.addrData.name = this.name;
          }       
          if(response.status == 222) {
            this.msg3 = response.data.message;
          } 
        })
        .catch(error => {
          if (error.response) {
              this.msg3 = '服务器响应错误'; // 服务器响应超时或服务器宕机等原因
          } else if (error.request) {
              this.msg3 = '请求未发出或未收到服务器响应'; // 例如服务器不允许跨域资源共享(CORS)
          } else {
              this.msg3 = '发生未知错误';
          }     
        });       
    },

    handleCopyStatus(status) {
      this.copySucceeded = status;
    },

    hideModal() {
      this.$refs['modal'].hide();
    },

    hideModalRemark() {
      this.$refs['modalRemark'].hide();
    },

    async view(rowIndex) {
      this.msg1 = ''; // 清空消息, 防止本窗口显示上次的消息
      this.msg2 = ''; // 必须清理, 否则模态窗口还会显示上次的消息

      var config = {
        method: 'post',
        url: 'download1',
        data: {
          gwcode: this.tableConfig.tableData[rowIndex]['gwcode'] // 商户订单号
        }
      };

      await this.$axios(config)
        .then(response => {
          if(response.status == 200) {
            this.key = response.data.key;
            this.$refs['modal'].show();
          }
          if(response.status == 202) {
            this.msg1 = response.data.message;
          }
        })
        .catch(error => {
          if (error.response) {
              this.msg1 = '服务器响应错误'; // 服务器响应超时或服务器宕机等原因
          } else if (error.request) {
              this.msg1 = '请求未发出或未收到服务器响应'; // 例如服务器不允许跨域资源共享(CORS)
          } else {
              this.msg1 = '发生未知错误';
          }
        });
    },

    modify_remark(rowIndex) {
      this.msgRemark = ''; // 清空模态窗口消息,防止显示上次窗口的消息
      this.remarkOriginalValue = this.tableConfig.tableData[rowIndex].remark;
      this.remarkValue = this.remarkOriginalValue;
      this.remarkGwcode = this.tableConfig.tableData[rowIndex].gwcode;
      this.remarkRowIndex = rowIndex;
      this.$refs['modalRemark'].show();
    },

    saveRemark() {
      this.msgRemark = ''; // 清空模态窗口消息,防止显示上次窗口的消息

      var config = {
        method: 'post',
        url: 'save_remark',
        data: {
          gwcode: this.remarkGwcode,
          remark: this.remarkValue
        }      
      }; 

      this.$axios(config)
        .then(response => {
          if(response.status === 200) {
            this.tableConfig.tableData[this.remarkRowIndex].remark = this.remarkValue;
            this.remarkOriginalValue = this.remarkValue;
            this.msgRemark = response.data.message;
          }      
          if(response.status === 222) {
            this.msgRemark = response.data.message;
          }
        })
        .catch(error => {
          if (error.response) {
              this.msgRemark = '服务器响应错误'; // 服务器响应超时或服务器宕机等原因
          } else if (error.request) {
              this.msgRemark = '请求未发出或未收到服务器响应'; // 例如服务器不允许跨域资源共享(CORS)
          } else {
              this.msgRemark = '发生未知错误';
          }    
        });      
    },
    
    download(rowIndex) {
      this.msg1 = ''; // 清空模态窗口消息,防止显示上次窗口的消息
      var config = {
        method: 'post',
        url: 'download1',
        data: {
          gwcode: this.tableConfig.tableData[rowIndex]['gwcode'] // 商户订单号
        }
      };

      this.$axios(config)
        .then(response => {
          if(response.status == 200) {
            var blob = new Blob([response.data.key], {type: "text/plain;charset=utf-8"});
            var filename = response.data.filename;
            saveAs(blob, filename);
          }
          if(response.status == 202) {
            this.msg1 = response.data.message;
          }
        })
        .catch(error => {
          if (error.response) {
              this.msg1 = '服务器响应错误'; // 服务器响应超时或服务器宕机等原因
          } else if (error.request) {
              this.msg1 = '请求未发出或未收到服务器响应'; // 例如服务器不允许跨域资源共享(CORS)
          } else {
              this.msg1 = '发生未知错误';
          }
        });
    },

    activation(rowIndex) {
      this.msg1 = ''; // 清空模态窗口消息,防止显示上次窗口的消息

      var config = {
        method: 'post',
        url: 'activation',
        data: {
          gwcode: this.tableConfig.tableData[rowIndex].gwcode,
          gwtype: this.tableConfig.tableData[rowIndex].gwtype
        }       
      };  
                    
      this.$axios(config)
        .then(response => {
          if(response.status == 200) {
            this.tableConfig.tableData[rowIndex].activated = true;
            this.msg1 = response.data.message;
          }       
          if(response.status == 222) {
            this.msg1 = response.data.message;
          } 
        })
        .catch(error => {
          if (error.response) {
              this.msg1 = '服务器响应错误'; // 服务器响应超时或服务器宕机等原因
          } else if (error.request) {
              this.msg1 = '请求未发出或未收到服务器响应'; // 例如服务器不允许跨域资源共享(CORS)
          } else {
              this.msg1 = '发生未知错误';
          }     
        });       
    },

    deactivate(rowIndex) {
      this.msg1 = ''; // 清空模态窗口消息,防止显示上次窗口的消息

      var config = {
        method: 'post',
        url: 'deactivate',
        data: {
          gwcode: this.tableConfig.tableData[rowIndex].gwcode,
          gwtype: this.tableConfig.tableData[rowIndex].gwtype
        }       
      };
            
      this.$axios(config)
        .then(response => {
          if(response.status == 200) {
            this.tableConfig.tableData[rowIndex].activated = false;
            this.msg1 = response.data.message;
          }       
          if(response.status == 222) {
            this.msg1 = response.data.message;
          }
        })
        .catch(error => { 
          if (error.response) {
              this.msg1 = '服务器响应错误'; // 服务器响应超时或服务器宕机等原因
          } else if (error.request) {
              this.msg1 = '请求未发出或未收到服务器响应'; // 例如服务器不允许跨域资源共享(CORS)
          } else {
              this.msg1 = '发生未知错误';
          }
        });
    },

    gwdelete(rowIndex) {
      this.msg1 = ''; // 清空模态窗口消息,防止显示上次窗口的消息

      var config = {
        method: 'post',
        url: 'gwdelete',
        data: {
          gwcode: this.tableConfig.tableData[rowIndex].gwcode,
          gwtype: this.tableConfig.tableData[rowIndex].gwtype
        }
      };

      this.$axios(config)
        .then(response => {
          if(response.status == 200) {
            this.tableConfig.tableData.splice(rowIndex, 1); // 直接在前台删除对应的行
            this.msg1 = response.data.message;
          }
          if(response.status == 222) {
            this.msg1 = response.data.message;
          }
        })
        .catch(error => {
          if (error.response) {
              this.msg1 = '服务器响应错误'; // 服务器响应超时或服务器宕机等原因
          } else if (error.request) {
              this.msg1 = '请求未发出或未收到服务器响应'; // 例如服务器不允许跨域资源共享(CORS)
          } else {
              this.msg1 = '发生未知错误';
          }
        });
    },



    headerCellClass(column, rowIndex) {
      if (rowIndex === 0) {
        return "table-header-cell-class";
      }
    },

    /*初始化时获得全部数据*/
    async getAllData() {
      var config = {
        method: 'post',
        url: 'account',
        data: {
          username: this.$store.state.username, // 客户端登录的用户名 电子邮箱
        }
      };

      await this.$axios(config)
        .then(response => {
          if(response.status == 200) {
            const jsonString = response.data.data;
            this.allData = JSON.parse(jsonString);
            this.dataNum = this.allData.length;
            this.getTableData();

            const addrString = response.data.addr;
            this.addrData = JSON.parse(addrString);
            this.name = this.addrData.name;
            this.address = this.addrData.address;
            this.phone = this.addrData.phone;

            const companyString = response.data.company;
            let companyData = JSON.parse(companyString);
            this.sldtld = companyData.sldtld;
            this.company_nbf = companyData.nbfstr;
            this.company_exp = companyData.expstr;
          }
        })
        .catch(error => {
          if (error.response) {
              this.msg1 = '服务器响应错误'; // 服务器响应超时或服务器宕机等原因
          } else if (error.request) {
              this.msg1 = '请求未发出或未收到服务器响应'; // 例如服务器不允许跨域资源共享(CORS)
          } else {
              this.msg1 = '发生未知错误';
          }   
        });
    },

    /*分页处理*/
    getTableData () {
      this.tableConfig.tableData = this.allData.slice(
        (this.pageIndex - 1) * this.pageSize,
        this.pageIndex * this.pageSize
      );
    },

    /*页码触发更新*/
    pageChange (pageIndex) {
      this.pageIndex = pageIndex
      this.getTableData()
      console.log(pageIndex)
    },

    /*每页条数触发更新*/
    pageSizeChange (pageSize) {
      this.pageIndex = 1
      this.pageSize = pageSize
      this.getTableData()
    }
  }
}
</script>


<style>

.tablePage {
  margin-left: 5px;
  padding: 0;
  height: 600px;
  width: 100%;
}

.p-a {
  margin-top: 25px;
  margin-bottom: 10px;
  color: #2185d0!important;
  font-weight: bold;
  font-size: 24px;
}

.ve-pagination {
  margin-top: 10px !important;
}

.table-header-cell-class {
  background: #C0C0C0 !important;
  font-weight: bold !important;
}

.button-demo {
  display:block;
  text-align:center;
  width:60px;
  height:35px;
  border-radius:3px;
  border:none;
  background-color:#1A8CDB;
  color:#fff;
  font-size:16px;
}

.button-close {
  min-width: 100%;
  height: 35px;
  display:block;
  border-radius:3px;
  border:none;
  background-color:#1A8CDB;
  color:#fff;
  font-size:16px;
}

.div-inline { 
  align: left;
  display: flex;
  flex-direction: row; 
  margin-bottom: 5px;
}

.div-inline1 { 
  justify-content: center; /* 水平居中 */
  display: flex;
  flex-direction: row; 
}

.message {
  color: red;
  margin-left: 3px;
}

[v-cloak] {
  display: none !important;
}

</style>
